'use client';

import { apiKeyClient } from '@better-auth/api-key/client';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  // Uses the current origin by default (e.g., http://localhost:3000).
  // Override via NEXT_PUBLIC_BETTER_AUTH_URL if the auth API is on a different host.
  baseURL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL,
  plugins: [apiKeyClient()],
});
